import styled from '@mui/system/styled';

export const DashboardsContentCnt = styled('div')({
  padding: '0 30px',
});
